import { api, formatDate, SslCertificate } from '../../api';
import { Alert, Loading, StatusTag, useAction, useLoad } from '../../Components/ui';
import type { TabProps } from './ControlPanel';

export default function SslTab({ base }: TabProps) {
    const { data: ssl, setData, error, loading } = useLoad(
        () => api.get<{ ssl: SslCertificate }>(`${base}/ssl`).then(r => r.data.ssl), [base]);
    const action = useAction();

    if (loading && !ssl) return <div className="panel-card"><Loading /></div>;
    if (error || !ssl) return <Alert type="error">{error ?? 'Could not load SSL status'}</Alert>;

    return (
        <div className="panel-card">
            <h3>SSL certificate</h3>
            {action.error && <Alert type="error">{action.error}</Alert>}
            <div className="kv-grid" style={{ marginBottom: '1.25rem' }}>
                <div><div className="kv-label">Status</div><div className="kv-value"><StatusTag status={ssl.status} /></div></div>
                <div><div className="kv-label">Issuer</div><div className="kv-value">{ssl.issuer ?? '—'}</div></div>
                <div><div className="kv-label">Expires</div><div className="kv-value">{formatDate(ssl.expiresAt)}</div></div>
                <div><div className="kv-label">Auto renew</div><div className="kv-value">{ssl.autoRenew ? 'On' : 'Off'}</div></div>
                {ssl.domains.length > 0 && <div><div className="kv-label">Covers</div><div className="kv-value mono">{ssl.domains.join(', ')}</div></div>}
            </div>
            <div className="fi-form" style={{ marginBottom: '1rem' }}>
                <label className="checkbox">
                    <input type="checkbox" checked={ssl.forceHttps} disabled={action.busy}
                        onChange={e => action.run(async () => setData((await api.put<{ ssl: SslCertificate }>(`${base}/ssl/force-https`, { enabled: e.target.checked })).data.ssl))} />
                    Redirect all HTTP traffic to HTTPS
                </label>
            </div>
            <button className="btn-outline small" disabled={action.busy}
                onClick={() => action.run(async () => setData((await api.post<{ ssl: SslCertificate }>(`${base}/ssl/issue`)).data.ssl))}>
                {ssl.status === 'active' ? 'Reissue certificate' : "Issue Let's Encrypt certificate"}
            </button>
        </div>
    );
}
